import { useApi, useCurrentUserType, UserType } from '@/hooks'
import useAuthStore from '@/stores/useAuthStore/useAuthStore'

/**
 * Custom hook to manage report access permissions
 * Checks for "Sustainability Full Access" role and determines user access levels
 *
 * @returns Object containing access control state and user type information
 */
export const useReportAccess = () => {
    const userType = useCurrentUserType()
    const { useGetRolesAndPermissions } = useApi()
    const { data, isLoading, isFetching, isFetched, isError, error } =
        useGetRolesAndPermissions()
    const customer = useAuthStore((state) => state.customer)

    const isAgentOrBroker =
        userType === UserType.AGENT || userType === UserType.BROKER
    const isCustomer = userType === UserType.CUSTOMER
    const isImpersonatingCustomer = isAgentOrBroker && !!customer

    const hasFullAccess =
        Array.isArray(data) &&
        data.some(
            (role: { name?: string }) =>
                role.name === 'Sustainability Full Access'
        )

    const shouldShowRestrictedContent =
        !hasFullAccess && (isCustomer || isImpersonatingCustomer)

    const isAgentOrBrokerWithoutCustomer = isAgentOrBroker && !customer

    return {
        hasFullAccess,
        shouldShowRestrictedContent,
        isAgentOrBrokerWithoutCustomer,
        userType,
        isCustomer,
        isImpersonatingCustomer,
        isLoading,
        isFetching,
        isFetched,
        isError,
        error,
    }
}
